<template>
  <div>
    <div v-if="isIconDisplayed" class="input-with-icon">
      <dir>
        <i :class="iconClass"></i>
      </dir>
      <div class="row">
        <input
          :id="id"
          :value="value"
          type="text"
          :placeholder="placeholder"
          @input="$emit('input', $event.target.value)"
        />
        <span v-if="isMandatory" class="error">{{ errorMessage }}</span>
      </div>
    </div>
    <div v-else class="input">
      <input
        :id="id"
        :value="value"
        type="text"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      />
      <span v-if="isMandatory" class="error">{{ errorMessage }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'input-id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    isIconDisplayed: {
      type: Boolean,
      default: false
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    errorMessage: ''
  },
  computed: {
    iconClass() {
      return `icon ${this.iconName}`;
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';

.input {
  display: flex;

  input {
    width: 100%;
  }
}
.input-with-icon {
  display: flex;
  justify-content: center;
  align-items: baseline;

  input {
    width: 90%;
  }
  i {
    margin: auto 0;
    margin-right: 12px;
  }
}

.error {
  font-size: small;
  color: @red-52;
  display: block;
}
</style>
